<template>
  <div style="margin-top:100px">
    <div>
      <a-row><a-col :span="24"><h1>我的记事本</h1></a-col></a-row>
      <a-row><a-col :span="24"><h5>域名有效期过了无法登录时点这个再登录：<a href="https://hjsite.com:9443/" target="_blank"> https://hjsite.com:9443/ </a></h5></a-col></a-row>
      <a-row>
        <a-col :span="2"></a-col>
        <a-col :span="20">
          <div style="margin-bottom: 16px">
            <a-input addon-before="账号：" v-model="account" />
          </div>
        </a-col>
        <a-col :span="2"></a-col>
      </a-row>
      <a-row>
        <a-col :span="2"></a-col>
        <a-col :span="16">
          <div style="margin-bottom: 16px">
            <a-input-password addon-before="密码：" v-model="password" />
          </div>
        </a-col>
        <a-col :span="4">
          <a-checkbox @change="rememberMeCheck" :checked="rememberMe">记住密码</a-checkbox>
        </a-col>
        <a-col :span="2"></a-col>
      </a-row>
      <a-row>
        <a-col :span="2"></a-col>
        <a-col :span="10">
          <div>
            <a-button type="primary" class="button-color-sunset" @click="registerForm" >注册</a-button>
          </div>
        </a-col>
        <a-col :span="10">
          <div>
            <a-button type="primary" @click="login" >登录</a-button>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
      </a-row>
    </div>
    <div align="center" style="color:gray;margin-top:300px">
      版权所有<br/>
      <a href="https://beian.miit.gov.cn">蜀ICP备15000907号</a>
    </div>
    <div>
      <a-modal v-model="registerModalVisible" title="注册新账号" @ok="register">
        <div>
          <div style="margin-bottom: 16px">
            <a-input addon-before="账号：" v-model="newAccount" />
          </div>
          <div style="margin-bottom: 16px">
            <a-input-password addon-before="密码：" v-model="newPassword1" />
          </div>
          <div style="margin-bottom: 16px">
            <a-input-password addon-before="重复密码：" v-model="newPassword2" />
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Vue from "vue";
  import router from "../../router";
  import Dashboard from "../personal/Dashboard";
  import VueCookies from 'vue-cookies'
  Vue.use(VueCookies)

  export default {
    name: 'LoginForm',
    data() {
      return {
        account:"",
        password:"",
        rememberMe:true,
        newAccount:"",
        newPassword1:"",
        newPassword2:"",
        registerModalVisible:false
      }
    },
    comments:{
      Dashboard
    },
    mounted() {
      this.account = Vue.$cookies.get("account");
      this.password = this.decoder(Vue.$cookies.get("password"));
      if(this.paramValue('fastlogin') == 1){
        this.login();
      }
    },
    methods:{
      encoder(txt){
        try{
          const len = new Date().getTime() % 6 + 3;
          const source = encodeURI(window.btoa(""+(Math.random()*10000000000)).substring(0,len)+txt+len);
          return window.btoa(source)
        }catch(e){
          return '';
        }
      },
      decoder(eny){
        try{
          const source = decodeURI(window.atob(eny))
          const len = source.substring(source.length-1, source.length);
          return source.substring(0+parseInt(len), source.length-1);
        }catch(e){
          return '';
        }
      },
      registerForm(){
        this.newAccount="";
        this.newPassword1="";
        this.newPassword2="";
        this.registerModalVisible = true;
      },
      register(){
        if(this.newPassword1 != this.newPassword2){
          alert("两次密码不一致");
          return;
        }
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/login/register', {
          "account":this.newAccount,
          "password":this.newPassword1
        },{}).then((response) => {
          let dt = response.data;
          if(dt.success){
            alert(dt.msg);
            this.account = this.newAccount;
            this.password = this.newPassword1;
            this.registerForm();
            this.registerModalVisible = false;
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      paramValue (param){
        let urlparam = window.location.search;
        let relparam = param + "=";
        let isparam = urlparam.indexOf(relparam);
        if (isparam < 0) return "";
        let start = isparam + relparam.length;
        let ismore = urlparam.indexOf("&", start);
        let end = ismore < 0 ? urlparam.length : ismore;
        return urlparam.substring(start, end);
      },
      rememberMeCheck(){
        this.rememberMe = !this.rememberMe;
      },
      login(){
        if(this.rememberMe){
          Vue.$cookies.set('account', this.account, '3d');
          Vue.$cookies.set('password', this.encoder(this.password), '3d');
        }else{
          Vue.$cookies.remove('account');
          Vue.$cookies.remove('password');
        }
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/login/token/get', {
          "account":this.account,
          "password":this.password,
          "type":"2"
        }).then(function (response) {
          var dt = response.data;
          if(dt.success){
            Vue.prototype.$global.SERVER_TOKEN = dt.token;
            router.push("/dashboard?token="+dt.token);
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/LoginForm.vue